module.exports = __webpack_public_path__ + "img/1516811130.25c94fe3.jpg";